(function () {
  'use strict';

  var GRADE_META = [
    { code: 'NM', color: '#22c55e', bg: 'rgba(34,197,94,0.13)',  border: 'rgba(34,197,94,0.40)'  },
    { code: 'LP', color: '#84cc16', bg: 'rgba(132,204,22,0.13)', border: 'rgba(132,204,22,0.40)' },
    { code: 'MP', color: '#f59e0b', bg: 'rgba(245,158,11,0.13)', border: 'rgba(245,158,11,0.40)' },
    { code: 'HP', color: '#f97316', bg: 'rgba(249,115,22,0.13)', border: 'rgba(249,115,22,0.40)' },
    { code: 'D',  color: '#ef4444', bg: 'rgba(239,68,68,0.13)',  border: 'rgba(239,68,68,0.40)'  }
  ];

  var SPEC_COLORS = [
    '#15803d,#22c55e',
    '#4d7c0f,#84cc16',
    '#b45309,#f59e0b',
    '#c2410c,#f97316',
    '#991b1b,#ef4444'
  ];

  var currentStep = 0;
  var grades      = [];
  var transformed = false;
  var uiRoot      = null;

  function parseGrades(container) {
    var parsed = [];
    container.querySelectorAll('.condition').forEach(function (cond, i) {
      var img   = cond.querySelector('img');
      var title = cond.querySelector('h4');
      var desc  = cond.querySelector('p');
      parsed.push({
        imgSrc : img   ? img.src                  : '',
        name   : title ? title.textContent.trim() : (GRADE_META[i] ? GRADE_META[i].code : ''),
        desc   : desc  ? desc.textContent.trim()  : '',
        meta   : GRADE_META[i] || GRADE_META[0]
      });
    });
    return parsed;
  }

  function buildUI(gradesData) {
    var root = document.createElement('div');
    root.className = 'dcg-gg-root';

    /* Spectrum bar */
    var spectrum = document.createElement('div');
    spectrum.className = 'dcg-gg-spectrum';
    gradesData.forEach(function (g, i) {
      var seg = document.createElement('button');
      seg.className = 'dcg-gg-seg' + (i === 0 ? ' active' : '');
      seg.type = 'button';
      seg.dataset.idx = i;
      seg.style.background = 'linear-gradient(135deg,' + SPEC_COLORS[i] + ')';
      seg.textContent = g.meta.code;
      seg.addEventListener('click', function () { goTo(parseInt(this.dataset.idx)); });
      spectrum.appendChild(seg);
    });
    root.appendChild(spectrum);

    /* Step view: column — image on top, content below */
    var stepView = document.createElement('div');
    stepView.className = 'dcg-gg-step';

    /* Image pane — full width, horizontal */
    var imgWrap = document.createElement('div');
    imgWrap.className = 'dcg-gg-img-wrap';
    var img = document.createElement('img');
    img.className = 'dcg-gg-img';
    img.alt = 'Card condition reference';
    imgWrap.appendChild(img);
    stepView.appendChild(imgWrap);

    /* Content pane */
    var content = document.createElement('div');
    content.className = 'dcg-gg-content';

    var topRow = document.createElement('div');
    topRow.className = 'dcg-gg-top-row';

    var badge = document.createElement('span');
    badge.className = 'dcg-gg-badge';

    var titleEl = document.createElement('div');
    titleEl.className = 'dcg-gg-title';

    topRow.appendChild(badge);
    topRow.appendChild(titleEl);

    var descEl = document.createElement('div');
    descEl.className = 'dcg-gg-desc';

    var divider = document.createElement('div');
    divider.className = 'dcg-gg-divider';

    /* Nav */
    var nav = document.createElement('div');
    nav.className = 'dcg-gg-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'dcg-gg-nav-btn';
    prevBtn.innerHTML = '&#8592; Prev';
    prevBtn.addEventListener('click', function () { goTo(currentStep - 1); });

    var dots = document.createElement('div');
    dots.className = 'dcg-gg-dots';
    gradesData.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dcg-gg-dot' + (i === 0 ? ' active' : '');
      dot.dataset.idx = i;
      dot.addEventListener('click', function () { goTo(parseInt(this.dataset.idx)); });
      dots.appendChild(dot);
    });

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'dcg-gg-nav-btn';
    nextBtn.innerHTML = 'Next &#8594;';
    nextBtn.addEventListener('click', function () { goTo(currentStep + 1); });

    nav.appendChild(prevBtn);
    nav.appendChild(dots);
    nav.appendChild(nextBtn);

    content.appendChild(topRow);
    content.appendChild(descEl);
    content.appendChild(divider);
    content.appendChild(nav);

    stepView.appendChild(content);
    root.appendChild(stepView);

    root._img     = img;
    root._imgWrap = imgWrap;
    root._badge   = badge;
    root._title   = titleEl;
    root._desc    = descEl;
    root._dots    = dots;
    root._prev    = prevBtn;
    root._next    = nextBtn;
    root._segs    = spectrum.querySelectorAll('.dcg-gg-seg');

    return root;
  }

  function goTo(idx) {
    if (!uiRoot || !grades.length) return;
    idx = Math.max(0, Math.min(grades.length - 1, idx));
    currentStep = idx;
    var g = grades[idx];
    var m = g.meta;

    uiRoot._img.src = g.imgSrc;
    uiRoot._img.alt = g.name;
    uiRoot._imgWrap.style.borderBottomColor = m.border;
    uiRoot._imgWrap.style.background =
      'linear-gradient(to bottom, rgba(0,0,0,0.32) 0%, ' + m.bg + ' 100%)';

    uiRoot._title.textContent = g.name;
    uiRoot._desc.textContent  = g.desc;

    uiRoot._badge.textContent = m.code;
    uiRoot._badge.style.cssText =
      'background:' + m.bg + ';color:' + m.color +
      ';border:1px solid ' + m.border +
      ';box-shadow:0 0 10px ' + m.border;

    uiRoot._segs.forEach(function (s, i) {
      s.classList.toggle('active', i === idx);
    });

    uiRoot._dots.querySelectorAll('.dcg-gg-dot').forEach(function (d, i) {
      d.classList.toggle('active', i === idx);
      d.style.background = i === idx ? m.color : '';
    });

    uiRoot._prev.disabled = (idx === 0);
    uiRoot._next.disabled = (idx === grades.length - 1);
  }

  function injectStyles() {
    if (document.getElementById('dcg-gg-styles')) return;
    var s = document.createElement('style');
    s.id = 'dcg-gg-styles';
    s.textContent =
      '.dcg-gg-root{display:flex;flex-direction:column;gap:14px}' +

      /* Spectrum */
      '.dcg-gg-spectrum{display:flex;border-radius:10px;overflow:hidden;height:38px;flex-shrink:0}' +
      '.dcg-gg-seg{flex:1;border:none;cursor:pointer;font-size:11px;font-weight:900;letter-spacing:0.08em;' +
        'color:rgba(255,255,255,0.55);transition:all .15s;opacity:0.40;border-right:1px solid rgba(0,0,0,0.20)}' +
      '.dcg-gg-seg:last-child{border-right:none}' +
      '.dcg-gg-seg.active{opacity:1;color:#fff}' +
      '.dcg-gg-seg:hover:not(.active){opacity:0.70}' +

      /* Step view: column */
      '.dcg-gg-step{display:flex;flex-direction:column;background:rgba(255,255,255,0.03);' +
        'border:1px solid rgba(255,255,255,0.07);border-radius:14px;overflow:hidden}' +

      /* Image pane — landscape, full width, fixed height */
      '.dcg-gg-img-wrap{width:100%;height:260px;display:flex;align-items:center;justify-content:center;' +
        'border-bottom:1px solid rgba(255,255,255,0.07);padding:20px;transition:background .3s,border-color .3s;' +
        'background:rgba(0,0,0,0.32)}' +
      '.dcg-gg-img{height:100%;width:auto;max-width:100%;border-radius:8px;display:block;' +
        'box-shadow:0 10px 40px rgba(0,0,0,0.75);object-fit:contain}' +

      /* Content below image */
      '.dcg-gg-content{display:flex;flex-direction:column;gap:12px;padding:22px 24px}' +

      /* Badge + title on one row */
      '.dcg-gg-top-row{display:flex;align-items:center;gap:12px}' +

      '.dcg-gg-badge{display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;' +
        'width:40px;height:40px;border-radius:50%;font-size:10px;font-weight:900;letter-spacing:0.06em;' +
        'border:1px solid;transition:all .2s}' +

      '.dcg-gg-title{font-size:20px;font-weight:700;color:rgba(255,255,255,0.92);line-height:1.2}' +

      '.dcg-gg-desc{font-size:13px;color:rgba(255,255,255,0.68);line-height:1.75}' +

      '.dcg-gg-divider{height:1px;background:rgba(255,255,255,0.07);margin:0}' +

      '.dcg-gg-nav{display:flex;align-items:center;gap:10px}' +
      '.dcg-gg-nav-btn{background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);' +
        'color:rgba(255,255,255,0.80);padding:7px 16px;border-radius:8px;cursor:pointer;' +
        'font-size:11px;font-weight:700;letter-spacing:0.04em;transition:all .15s}' +
      '.dcg-gg-nav-btn:hover:not(:disabled){background:rgba(255,122,0,0.12);' +
        'border-color:rgba(255,122,0,0.40);color:#fff}' +
      '.dcg-gg-nav-btn:disabled{opacity:0.22;cursor:not-allowed}' +

      '.dcg-gg-dots{display:flex;gap:6px;align-items:center;margin:0 auto}' +
      '.dcg-gg-dot{width:7px;height:7px;border-radius:50%;border:none;cursor:pointer;' +
        'background:rgba(255,255,255,0.18);padding:0;transition:all .15s;flex-shrink:0}' +
      '.dcg-gg-dot:hover{background:rgba(255,255,255,0.40)}' +
      '.dcg-gg-dot.active{width:9px;height:9px}' +

      '@media(max-width:560px){' +
        '.dcg-gg-img-wrap{height:180px;padding:14px}' +
        '.dcg-gg-content{padding:16px}' +
      '}';
    document.head.appendChild(s);
  }

  function transformModal() {
    var container = document.querySelector('#myModal .gradingGuideContainer');
    if (!container) return;
    var chartDes = document.querySelector('#myModal .custom_size_chart_des');
    if (!chartDes) return;
    grades = parseGrades(container);
    if (!grades.length) return;
    currentStep = 0;
    injectStyles();
    uiRoot = buildUI(grades);
    chartDes.innerHTML = '';
    chartDes.appendChild(uiRoot);
    goTo(0);
    transformed = true;
  }

  function handleKey(e) {
    var modal = document.getElementById('myModal');
    if (!modal || (!modal.classList.contains('in') && modal.style.display === 'none')) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') goTo(currentStep + 1);
    if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   goTo(currentStep - 1);
  }

  function init() {
    var modal = document.getElementById('myModal');
    if (!modal) return;
    $(modal).on('shown.bs.modal', function () {
      if (!transformed) transformModal();
    });
    var observer = new MutationObserver(function () {
      if (!transformed && modal.classList.contains('in')) transformModal();
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['class', 'style'] });
    document.addEventListener('keydown', handleKey);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
